exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".md-direction-bottom-right{width:18%!important}.center{text-align:center}.b-form-input-container{margin:4px 0 12px!important}.activeClass{display:none}.error{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-39930efe","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/freightForwarding/newffExecution.vue
// module id = 1509
// module chunks = 0